export default __webpack_public_path__ + "static/media/labrix.b9f1a358.woff";